import { Button, Icon, Typography, XStack, YStack } from '@shinetools/lumen-react'
import { colors } from '@shinetools/lumen-tokens/web/colors'
import { ArrowLeftRight, WandSparkles, X } from 'lucide-react'
import { useTranslation } from 'react-i18next'

interface ReconciliationViewCustomBannerProps {
  actionLabel: string
  message: string
  onAction: () => void
  onDismiss: () => void
  title: string
}

export const ReconciliationViewCustomBanner = ({
  actionLabel,
  message,
  onAction,
  onDismiss,
  title,
}: ReconciliationViewCustomBannerProps) => {
  const { t } = useTranslation()

  return (
    <XStack
      align="center"
      gap={12}
      paddingHorizontal={24}
      paddingVertical={12}
      role="status"
      style={{ backgroundColor: colors.surface.accent.subtle.default, color: colors.content.black }}
    >
      <Icon icon={WandSparkles} />
      <YStack flex={1}>
        <Typography.Text color={colors.content.black}>
          <Typography.Text color={colors.content.black} weight="semibold">
            {title}
          </Typography.Text>{' '}
          {message}
        </Typography.Text>
      </YStack>
      <Button
        color="accent"
        label={actionLabel}
        startIcon={<Icon icon={ArrowLeftRight} size="small" />}
        variant="tonal"
        onColor
        onClick={onAction}
      />
      <Button
        aria-label={t('bank_transactions.reconciliation_view_banner.dismiss')}
        color="primary"
        icon={<Icon icon={X} />}
        size="small"
        variant="text"
        onClick={onDismiss}
      />
    </XStack>
  )
}
